// extracted by mini-css-extract-plugin
export default {"tab-transparent":"TabTransparent_tab-transparent__srFhd","tab-transparent_chosen":"TabTransparent_tab-transparent_chosen__SNUw0"};